import { render, staticRenderFns } from "./MobDetail.vue?vue&type=template&id=8efe91e0&scoped=true&"
import script from "./MobDetail.vue?vue&type=script&lang=js&"
export * from "./MobDetail.vue?vue&type=script&lang=js&"
import style0 from "./MobDetail.vue?vue&type=style&index=0&id=8efe91e0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8efe91e0",
  null
  
)

export default component.exports